import { render, staticRenderFns } from "./EmailReceivers.vue?vue&type=template&id=e5ef9340"
import script from "./EmailReceivers.vue?vue&type=script&lang=ts"
export * from "./EmailReceivers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports